export const attributesNames = {
  RESOURCES: 'resources',
  VARIABLES: 'variables',
  PRODUCTS: 'products',
  WEATHER_DATA: 'weather_data',
  LOCATIONS: 'locations',
  PARAMETERS: 'parameters'
}
